import React from "react";
import CSS from "react-css-modules";

import eineLogo from "assets/images/eine_logo.png";

import styles from "./style.scss";

class Footer extends React.Component {
  render() {
    return (
      <div styleName="footer">
        <div>
          <img src={eineLogo} alt="로고" />
          <p>
            Contact :{" "}
            <a href="mailto:help@global.chatie.me">help@global.chatie.me</a>
          </p>
          <span>Copyright © EINEBLUME CO., LTD. 2022 All Rights Reserved</span>
        </div>
      </div>
    );
  }
}

const Component = CSS(Footer, styles);

export default Component;



// WEBPACK FOOTER //
// ./src/app/components/common/Footer/index.js